export default __webpack_public_path__ + "img/thermal-5483b2fe49a97b203cc6b3399a327ef5.png";